import { AVEC_EXTRAS_VILA, AVEC_EXTRAS_OSCAR, AVEC_EXTRAS_MOEMA, AVEC_EXTRAS_ITAIM, AVEC_EXTRAS_JARDINS, AVEC_PRO_VILA, AVEC_PRO_MOEMA, AVEC_PRO_ITAIM, AVEC_PRO_OSCAR, AVEC_PRO_JARDINS, AVEC_COM_VILA, AVEC_COM_MOEMA, AVEC_COM_ITAIM, AVEC_COM_OSCAR, AVEC_COM_JARDINS, AVEC_VILA_OLIMPIA, AVEC_MOEMA, AVEC_ITAIM_BIBI, AVEC_OSCAR_FREIRE, AVEC_JARDINS, AVEC_SEM_PREF_VILA, AVEC_SEM_PREF_MOEMA, AVEC_SEM_PREF_ITAIM, AVEC_SEM_PREF_OSCAR, AVEC_SEM_PREF_JARDINS, AVEC_PREF_VILA, AVEC_PREF_MOEMA, AVEC_PREF_ITAIM, AVEC_PREF_OSCAR, AVEC_PREF_JARDINS } from './avecExtractedData.js';
import { SEED_TRAVADO } from '../config/featureFlags.js';

export const SEED_UNITS = [
  { id: 'unit-moema', name: 'Moema', city: 'São Paulo', address: 'Al. dos Nhambiquaras, 1200', phone: '(11) 3051-0000', manager: 'Gerente Moema', active: true, createdAt: '2023-01-01' },
  { id: 'unit-oscar', name: 'Oscar Freire', city: 'São Paulo', address: 'R. Oscar Freire, 800', phone: '(11) 3064-0000', manager: 'Gerente Oscar Freire', active: true, createdAt: '2023-01-01' },
  { id: 'unit-jardins', name: 'Jardins', city: 'São Paulo', address: 'R. Augusta, 2200', phone: '(11) 3062-0000', manager: 'Gerente Jardins', active: true, createdAt: '2023-01-01' },
  { id: 'unit-itaim', name: 'Itaim Bibi', city: 'São Paulo', address: 'R. Joaquim Floriano, 72', phone: '(11) 3078-0000', manager: 'Gerente Itaim', active: true, createdAt: '2023-01-01' },
  { id: 'unit-vila', name: 'Vila Olímpia', city: 'São Paulo', address: 'R. Funchal, 418', phone: '(11) 3044-0000', manager: 'Gerente Vila Olímpia', active: true, createdAt: '2023-01-01' },
];

export const SEED_PROFESSIONALS = [
  // ── Jardins (8) ──
  { id: 'p-jardins-caio', name: 'Caio', unitId: 'unit-jardins', role: 'Barbeiro', phone: '', email: '', hireDate: '2025-12-01', active: true, userId: 'user-caio-jardins' },
  { id: 'p-jardins-henrique', name: 'Henrique', unitId: 'unit-jardins', role: 'Barbeiro', phone: '', email: '', hireDate: '2025-12-01', active: true, userId: 'user-henrique-jardins' },
  { id: 'p-jardins-renato', name: 'Renato', unitId: 'unit-jardins', role: 'Barbeiro', phone: '', email: '', hireDate: '2026-02-13', active: true, userId: 'user-renato-jardins' },
  { id: 'p-jardins-isabela', name: 'Isabela', unitId: 'unit-jardins', role: 'Esteticista', phone: '', email: '', hireDate: '2025-12-01', active: true, userId: 'user-isabela-jardins' },
  { id: 'p-jardins-isabelly', name: 'Isabelly', unitId: 'unit-jardins', role: 'Recepcionista', phone: '', email: '', hireDate: '2025-12-01', active: true, userId: 'user-isabelly-jardins' },
  { id: 'p-jardins-jhenifer', name: 'Jhenifer', unitId: 'unit-jardins', role: 'Manicure', phone: '', email: '', hireDate: '2025-12-01', active: true, userId: 'user-jhenifer-jardins' },
  { id: 'p-jardins-giulia', name: 'Giulia', unitId: 'unit-jardins', role: 'Assistente', phone: '', email: '', hireDate: '2025-12-01', active: true, userId: 'user-giulia-jardins' },
  { id: 'p-jardins-eduarda', name: 'Eduarda', unitId: 'unit-jardins', role: 'Assistente', phone: '', email: '', hireDate: '2025-12-01', active: true, userId: 'user-eduarda-jardins' },

  // ── Vila Olímpia (9) ──
  { id: 'p-vila-day', name: 'Day', unitId: 'unit-vila', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-11-01', active: true, userId: 'user-day-vila', aliases: ['Daiane Fabiano dos Santos', 'Daiane Fabiano'] },
  { id: 'p-vila-gringo', name: 'Gringo', unitId: 'unit-vila', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-06-01', active: true, userId: 'user-gringo-vila', aliases: ['Eduardo Isaac Chacon Mansilla', 'Eduardo Chacon'] },
  { id: 'p-vila-leonardo', name: 'Leonardo', unitId: 'unit-vila', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-08-15', active: true, userId: 'user-leonardo-vila' },
  { id: 'p-vila-luan', name: 'Luan', unitId: 'unit-vila', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-09-01', active: true, userId: 'user-luan-vila' },
  { id: 'p-vila-matheus', name: 'Matheus', unitId: 'unit-vila', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-04-10', active: true, userId: 'user-matheus-vila' },
  { id: 'p-vila-anna-jullya', name: 'Anna Jullya', unitId: 'unit-vila', role: 'Recepcionista', phone: '', email: '', hireDate: '2023-01-01', active: true, userId: 'user-anna-jullya-vila', aliases: ['Ana Jullya'] },
  { id: 'p-vila-ana-vitoria', name: 'Ana Vitória', unitId: 'unit-vila', role: 'Recepcionista', phone: '', email: '', hireDate: '2023-01-01', active: true, userId: 'user-ana-vitoria-vila' },
  { id: 'p-vila-jhenifer-lopes', name: 'Jhenifer Lopes', unitId: 'unit-vila', role: 'Assistente', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-jhenifer-lopes-vila' },
  { id: 'p-vila-julia', name: 'Julia', unitId: 'unit-vila', role: 'Assistente', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-julia-vila' },
  { id: 'p-vila-beatriz', name: 'Beatriz', unitId: 'unit-vila', role: 'Gerente', phone: '', email: '', hireDate: '2026-01-01', active: true, userId: 'user-beatriz-vila', managerVariable: 1750 },

  // ── Itaim Bibi (6) ──
  { id: 'p-itaim-diego', name: 'Diego', unitId: 'unit-itaim', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-01-01', active: true, userId: 'user-diego-itaim' },
  { id: 'p-itaim-fernando', name: 'Fernando', unitId: 'unit-itaim', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-01-01', active: true, userId: 'user-fernando-itaim' },
  { id: 'p-itaim-matheus', name: 'Matheus', unitId: 'unit-itaim', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-09-01', active: true, userId: 'user-matheus-itaim' },
  { id: 'p-itaim-victoria', name: 'Victória', unitId: 'unit-itaim', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-victoria-itaim' },
  { id: 'p-itaim-eduarda', name: 'Eduarda', unitId: 'unit-itaim', role: 'Recepcionista', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-eduarda-itaim' },
  { id: 'p-itaim-maria-eloysa', name: 'Maria Eloysa', unitId: 'unit-itaim', role: 'Recepcionista', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-maria-eloysa-itaim' },

  // ── Moema (11) ──
  { id: 'p-moema-dan', name: 'Dan', unitId: 'unit-moema', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-03-15', active: true, userId: 'user-dan-moema' },
  { id: 'p-moema-kayk', name: 'Kayk', unitId: 'unit-moema', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-05-10', active: true, userId: 'user-kayk-moema' },
  { id: 'p-moema-mariana', name: 'Mariana', unitId: 'unit-moema', role: 'Recepcionista', phone: '', email: '', hireDate: '2023-01-20', active: true, userId: 'user-mariana-moema' },
  { id: 'p-moema-narciso', name: 'Narciso', unitId: 'unit-moema', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-01-01', active: true, userId: 'user-narciso-moema' },
  { id: 'p-moema-regiane', name: 'Regiane', unitId: 'unit-moema', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-03-01', active: true, userId: 'user-regiane-moema' },
  { id: 'p-moema-eduardo', name: 'Eduardo', unitId: 'unit-moema', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-eduardo-moema' },
  { id: 'p-moema-henrique', name: 'Henrique', unitId: 'unit-moema', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-08-01', active: true, userId: 'user-henrique-moema' },
  { id: 'p-moema-duda', name: 'Duda', unitId: 'unit-moema', role: 'Recepcionista', phone: '', email: '', hireDate: '2023-02-01', active: true, userId: 'user-duda-moema' },
  { id: 'p-moema-katy', name: 'Katy', unitId: 'unit-moema', role: 'Manicure', phone: '', email: '', hireDate: '2023-05-01', active: true, userId: 'user-katy-moema' },
  { id: 'p-moema-ana', name: 'Ana', unitId: 'unit-moema', role: 'Assistente', phone: '', email: '', hireDate: '2023-09-15', active: true, userId: 'user-ana-moema' },
  { id: 'p-moema-kauanny', name: 'Kauanny', unitId: 'unit-moema', role: 'Assistente', phone: '', email: '', hireDate: '2023-09-15', active: true, userId: 'user-kauanny-moema' },
  { id: 'p-moema-nicoli', name: 'Nicoli', unitId: 'unit-moema', role: 'Recepcionista', phone: '', email: '', hireDate: '2026-01-01', active: true, userId: 'user-nicoli-moema' },

  // ── Oscar Freire (8) ──
  { id: 'p-oscar-franco', name: 'Franco', unitId: 'unit-oscar', role: 'Barbeiro', phone: '', email: '', hireDate: '2022-02-01', active: true, userId: 'user-franco-oscar' },
  { id: 'p-oscar-gabriel', name: 'Gabriel', unitId: 'unit-oscar', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-03-15', active: true, userId: 'user-gabriel-oscar' },
  { id: 'p-oscar-luiz-grolla', name: 'Luiz Grolla', unitId: 'unit-oscar', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-01-01', active: true, userId: 'user-luiz-grolla-oscar' },
  { id: 'p-oscar-pedro', name: 'Pedro', unitId: 'unit-oscar', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-01-01', active: true, userId: 'user-pedro-oscar' },
  { id: 'p-oscar-victor', name: 'Victor', unitId: 'unit-oscar', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-victor-oscar' },
  { id: 'p-oscar-giovanna', name: 'Giovanna', unitId: 'unit-oscar', role: 'Recepcionista', phone: '', email: '', hireDate: '2023-04-10', active: true, userId: 'user-giovanna-oscar' },
  { id: 'p-oscar-maria', name: 'Maria', unitId: 'unit-oscar', role: 'Assistente', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-maria-oscar' },
  { id: 'p-oscar-sarah', name: 'Sarah', unitId: 'unit-oscar', role: 'Assistente', phone: '', email: '', hireDate: '2023-06-01', active: true, userId: 'user-sarah-oscar' },
  { id: 'p-oscar-emilly', name: 'Emilly', unitId: 'unit-oscar', role: 'Recepcionista', phone: '', email: '', hireDate: '2026-03-01', active: true, userId: 'user-emilly-oscar' },
  { id: 'p-oscar-renato', name: 'Renato', unitId: 'unit-oscar', role: 'Barbeiro', phone: '', email: '', hireDate: '2023-01-01', active: false, deactivatedAt: '2026-02-12', userId: 'user-renato-oscar' },
];

// 16/10/2026 (segurança P9): o seed ia no bundle PÚBLICO com as senhas em texto
// e os e-mails de login da empresa — lista pronta de alvos. O login é 100%
// servidor desde 02/10 (fk_users no bucket privado), então o seed não leva mais
// senha nem e-mail de login (campos vazios). tests/auth-endpoints.test.mjs confere.
export const SEED_USERS = [
  { id: 'admin-001', name: 'Administrador Feel King', email: '', role: 'admin', professionalId: null, active: true, createdAt: '2023-01-01' },
  // Jardins
  { id: 'user-caio-jardins', name: 'Caio', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-jardins-caio', active: true, createdAt: '2025-12-01' },
  { id: 'user-henrique-jardins', name: 'Henrique', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-jardins-henrique', active: true, createdAt: '2025-12-01' },
  { id: 'user-renato-jardins', name: 'Renato', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-jardins-renato', active: true, createdAt: '2025-12-01' },
  { id: 'user-isabela-jardins', name: 'Isabela', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-jardins-isabela', active: true, createdAt: '2025-12-01' },
  { id: 'user-isabelly-jardins', name: 'Isabelly', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-jardins-isabelly', active: true, createdAt: '2025-12-01' },
  { id: 'user-jhenifer-jardins', name: 'Jhenifer', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-jardins-jhenifer', active: true, createdAt: '2025-12-01' },
  { id: 'user-giulia-jardins', name: 'Giulia', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-jardins-giulia', active: true, createdAt: '2025-12-01' },
  { id: 'user-eduarda-jardins', name: 'Eduarda', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-jardins-eduarda', active: true, createdAt: '2025-12-01' },
  // Vila Olímpia
  { id: 'user-day-vila', name: 'Day', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-day', active: true, createdAt: '2022-11-01' },
  { id: 'user-gringo-vila', name: 'Gringo', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-gringo', active: true, createdAt: '2022-06-01' },
  { id: 'user-leonardo-vila', name: 'Leonardo', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-leonardo', active: true, createdAt: '2022-08-15' },
  { id: 'user-luan-vila', name: 'Luan', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-luan', active: true, createdAt: '2022-09-01' },
  { id: 'user-matheus-vila', name: 'Matheus', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-matheus', active: true, createdAt: '2022-04-10' },
  { id: 'user-anna-jullya-vila', name: 'Anna Jullya', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-anna-jullya', active: true, createdAt: '2023-01-01' },
  { id: 'user-ana-vitoria-vila', name: 'Ana Vitória', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-ana-vitoria', active: true, createdAt: '2023-01-01' },
  { id: 'user-jhenifer-lopes-vila', name: 'Jhenifer Lopes', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-jhenifer-lopes', active: true, createdAt: '2023-06-01' },
  { id: 'user-julia-vila', name: 'Julia', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-vila-julia', active: true, createdAt: '2023-06-01' },
  { id: 'user-beatriz-vila', name: 'Beatriz', email: '', mustChangePassword: true, role: 'admin', professionalId: 'p-vila-beatriz', active: true, createdAt: '2026-01-01' },
  // Itaim Bibi
  { id: 'user-diego-itaim', name: 'Diego', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-itaim-diego', active: true, createdAt: '2023-01-01' },
  { id: 'user-fernando-itaim', name: 'Fernando', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-itaim-fernando', active: true, createdAt: '2023-01-01' },
  { id: 'user-matheus-itaim', name: 'Matheus', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-itaim-matheus', active: true, createdAt: '2022-09-01' },
  { id: 'user-victoria-itaim', name: 'Victória', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-itaim-victoria', active: true, createdAt: '2023-06-01' },
  { id: 'user-eduarda-itaim', name: 'Eduarda', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-itaim-eduarda', active: true, createdAt: '2023-06-01' },
  { id: 'user-maria-eloysa-itaim', name: 'Maria Eloysa', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-itaim-maria-eloysa', active: true, createdAt: '2023-06-01' },
  // Moema
  { id: 'user-dan-moema', name: 'Dan', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-dan', active: true, createdAt: '2022-03-15' },
  { id: 'user-kayk-moema', name: 'Kayk', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-kayk', active: true, createdAt: '2022-05-10' },
  { id: 'user-mariana-moema', name: 'Mariana', email: '', mustChangePassword: true, role: 'receptionist', professionalId: 'p-moema-mariana', active: true, createdAt: '2023-01-20' },
  { id: 'user-narciso-moema', name: 'Narciso', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-narciso', active: true, createdAt: '2023-01-01' },
  { id: 'user-regiane-moema', name: 'Regiane', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-regiane', active: true, createdAt: '2023-03-01' },
  { id: 'user-eduardo-moema', name: 'Eduardo', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-eduardo', active: true, createdAt: '2023-06-01' },
  { id: 'user-henrique-moema', name: 'Henrique', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-henrique', active: true, createdAt: '2023-08-01' },
  { id: 'user-duda-moema', name: 'Duda', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-duda', active: true, createdAt: '2023-02-01' },
  { id: 'user-katy-moema', name: 'Katy', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-katy', active: true, createdAt: '2023-05-01' },
  { id: 'user-ana-moema', name: 'Ana', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-ana', active: true, createdAt: '2023-09-15' },
  { id: 'user-kauanny-moema', name: 'Kauanny', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-kauanny', active: true, createdAt: '2023-09-15' },
  { id: 'user-nicoli-moema', name: 'Nicoli', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-moema-nicoli', active: true, createdAt: '2026-01-01' },
  // Oscar Freire
  { id: 'user-franco-oscar', name: 'Franco', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-franco', active: true, createdAt: '2022-02-01' },
  { id: 'user-gabriel-oscar', name: 'Gabriel', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-gabriel', active: true, createdAt: '2023-03-15' },
  { id: 'user-luiz-grolla-oscar', name: 'Luiz Grolla', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-luiz-grolla', active: true, createdAt: '2023-01-01' },
  { id: 'user-pedro-oscar', name: 'Pedro', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-pedro', active: true, createdAt: '2023-01-01' },
  { id: 'user-victor-oscar', name: 'Victor', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-victor', active: true, createdAt: '2023-06-01' },
  { id: 'user-giovanna-oscar', name: 'Giovanna', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-giovanna', active: true, createdAt: '2023-04-10' },
  { id: 'user-maria-oscar', name: 'Maria', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-maria', active: true, createdAt: '2023-06-01' },
  { id: 'user-sarah-oscar', name: 'Sarah', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-sarah', active: true, createdAt: '2023-06-01' },
  { id: 'user-emilly-oscar', name: 'Emilly', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-emilly', active: true, createdAt: '2026-03-01' },
  { id: 'user-renato-oscar', name: 'Renato', email: '', mustChangePassword: true, role: 'professional', professionalId: 'p-oscar-renato', active: false, createdAt: '2023-01-01' },
];

export const SEED_SERVICES = [
  // ── Serviços principais (não aparecem como extras) ──
  { id: 'svc-corte', name: 'Corte', category: 'Geral', price: 128, active: true },
  { id: 'svc-corte-barba-completa', name: 'Corte de Cabelo Barba completa', category: 'Geral', price: 188, active: true },
  { id: 'svc-barba-completa', name: 'Barba Completa', category: 'Geral', price: 84, active: true },
  { id: 'svc-acabamento', name: 'Acabamento Cabelo', category: 'Geral', price: 55, active: true },
  { id: 'svc-combo-black', name: 'Combo Black', category: 'Geral', price: 120, active: true },
  { id: 'svc-corte-visagista', name: 'Corte Visagista', category: 'Geral', price: 280, active: true },
  { id: 'svc-corte-barba-visagista', name: 'Corte e barba Visagista', category: 'Geral', price: 325, active: true },
  { id: 'svc-barba-visagista', name: 'Barba Visagista', category: 'Geral', price: 180, active: true },

  // ── Serviços Extras: Barbeiro ──
  { id: 'svc-sobrancelha', name: 'Sobrancelha', category: 'Barbeiro', price: 60, active: true },
  { id: 'svc-barboterapia', name: 'Barboterapia', category: 'Barbeiro', price: 50, active: true },
  { id: 'svc-botox', name: 'Botox Capilar', category: 'Barbeiro', price: 208, active: true },
  { id: 'svc-depilacao', name: 'Depilação', category: 'Barbeiro', price: 60, active: true },
  { id: 'svc-terapia-facial', name: 'Terapia Facial', category: 'Barbeiro', price: 120, active: true },
  { id: 'svc-mascara-argila', name: 'Máscara de Argila', category: 'Barbeiro', price: 80, active: true },
  { id: 'svc-disfarce', name: 'Disfarce de Grisalhos', category: 'Barbeiro', price: 145, active: true },

  // ── Serviços Extras: Assistente ──
  { id: 'svc-lavagem-especial', name: 'Lavagem Especial', category: 'Assistente', price: 50, active: true },
  { id: 'svc-hidratacao', name: 'Hidratação', category: 'Assistente', price: 85, active: true },

  // ── Serviços Extras: Manicure ──
  { id: 'svc-manicure-pedicure', name: 'Manicure e Pedicure', category: 'Manicure', price: 80, active: true },
  { id: 'svc-spa-pes', name: 'Spa dos Pés', category: 'Manicure', price: 90, active: true },
  { id: 'svc-massagem-pes', name: 'Massagem nos Pés', category: 'Manicure', price: 70, active: true },
  { id: 'svc-reflexologia', name: 'Reflexologia', category: 'Manicure', price: 80, active: true },
  { id: 'svc-hidratacao-pes', name: 'Hidratação nos Pés', category: 'Manicure', price: 60, active: true },

  // ── Serviços Extras: Esteticista ──
  { id: 'svc-drenagem-linfatica', name: 'Drenagem Linfática 50min', category: 'Esteticista', price: 150, active: true },
  { id: 'svc-laser-abdomen', name: 'Laser - Abdômen', category: 'Esteticista', price: 200, active: true },
  { id: 'svc-laser-axila', name: 'Laser - Axila', category: 'Esteticista', price: 120, active: true },
  { id: 'svc-laser-barba-completa', name: 'Laser - Barba Completa', category: 'Esteticista', price: 180, active: true },
  { id: 'svc-laser-bracos', name: 'Laser - Braços Completos', category: 'Esteticista', price: 250, active: true },
  { id: 'svc-laser-contorno-barba', name: 'Laser - Contorno de Barba', category: 'Esteticista', price: 150, active: true },
  { id: 'svc-laser-costas', name: 'Laser - Costas', category: 'Esteticista', price: 250, active: true },
  { id: 'svc-laser-nuca', name: 'Laser - Nuca', category: 'Esteticista', price: 100, active: true },
  { id: 'svc-laser-ombros', name: 'Laser - Ombros', category: 'Esteticista', price: 150, active: true },
  { id: 'svc-laser-peito', name: 'Laser - Peito', category: 'Esteticista', price: 200, active: true },
  { id: 'svc-laser-pernas', name: 'Laser - Pernas Inteiras', category: 'Esteticista', price: 350, active: true },
  { id: 'svc-limpeza-pele', name: 'Limpeza de Pele Profunda', category: 'Esteticista', price: 180, active: true },
  { id: 'svc-massagem-cranio-facial', name: 'Massagem Crânio Facial', category: 'Esteticista', price: 120, active: true },
  { id: 'svc-massagem-dorsal', name: 'Massagem Dorsal', category: 'Esteticista', price: 100, active: true },
  { id: 'svc-massagem-dorsal-40', name: 'Massagem Dorsal 40min', category: 'Esteticista', price: 130, active: true },
  { id: 'svc-massagem-relaxante-30', name: 'Massagem Relaxante 30min', category: 'Esteticista', price: 90, active: true },
  { id: 'svc-massagem-relaxante-60', name: 'Massagem Relaxante 60min', category: 'Esteticista', price: 160, active: true },
  { id: 'svc-massagem-terapeutica-30', name: 'Massagem Terapêutica 30min', category: 'Esteticista', price: 100, active: true },
  { id: 'svc-massagem-terapeutica-60', name: 'Massagem Terapêutica 60min', category: 'Esteticista', price: 180, active: true },
  { id: 'svc-peeling-facial', name: 'Peeling Facial', category: 'Esteticista', price: 150, active: true },
  { id: 'svc-revitalizacao-facial', name: 'Revitalização Facial', category: 'Esteticista', price: 160, active: true },
  { id: 'svc-anti-idade', name: 'Tratamento Anti Idade', category: 'Esteticista', price: 200, active: true },
  { id: 'svc-anti-acne', name: 'Tratamento Anti Acne', category: 'Esteticista', price: 180, active: true },
  { id: 'svc-ventosa', name: 'Ventosa', category: 'Esteticista', price: 80, active: true },
];

export const SEED_PACKAGES = [
  { id: 'pkg-premium', name: 'Pacote Premium', description: 'Corte + Barba + Hidratação', price: 150, sessions: 1, active: true },
  { id: 'pkg-vip', name: 'Pacote VIP', description: 'Corte + Barba + Spa + Sobrancelha', price: 220, sessions: 1, active: true },
  { id: 'pkg-basic', name: 'Pacote Básico', description: 'Corte + Barba', price: 80, sessions: 1, active: true },
];

function genUnitPerf(unitId, year, month, base) {
  const seed = (unitId + year + month).split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  const rng = (min, max, n = 0) => min + (((seed + n * 97) * 9301 + 49297) % 233280) / 233280 * (max - min);
  const fat = Math.round(base * (0.85 + rng(0, 0.3)));
  const servicos = Math.round((250 + rng(0, 200, 1)) * (0.85 + rng(0, 0.3, 2)));
  const clientes = Math.round(servicos * (0.55 + rng(0, 0.15, 3)));
  return {
    id: `uperf-${unitId}-${year}-${month}`,
    unitId, year, month,
    faturamento: fat,
    comissao: Math.round(fat * (0.38 + rng(0, 0.08, 4))),
    servicosRealizados: servicos,
    clientesAtendidos: clientes,
    clientesNovos: Math.round(25 + rng(0, 50, 5)),
    geracaoDemanda: Math.round(25 + rng(0, 50, 5)),
    agendamentosPreferenciais: Math.round(servicos * 0.25),
    semPreferencia: Math.round(servicos * 0.15),
    ticketMedio: clientes > 0 ? Math.round(fat / clientes) : 0,
    produtosVendidos: Math.round(15 + rng(0, 40, 6)),
    faturamentoProdutos: Math.round(500 + rng(0, 2000, 9)),
    taxaRetorno: Math.round(65 + rng(0, 20, 7)),
    satisfacao: Math.round(80 + rng(0, 15, 8)),
    observacoes: '',
    updatedAt: '2024-01-01T00:00:00.000Z'
  };
}

const baseUnitFat = {
  'unit-moema': 45000, 'unit-oscar': 28000, 'unit-jardins': 40000,
  'unit-itaim': 35000, 'unit-vila': 32000,
};

export const SEED_UNIT_PERFORMANCE = [];
SEED_UNITS.forEach(u => {
  [2024, 2025].forEach(year => {
    const months = year === 2024 ? [9,10,11,12] : [1,2,3,4,5,6,7,8,9,10,11,12];
    months.forEach(month => {
      SEED_UNIT_PERFORMANCE.push(genUnitPerf(u.id, year, month, baseUnitFat[u.id] || 30000));
    });
  });
  [1,2,3].forEach(month => {
    SEED_UNIT_PERFORMANCE.push(genUnitPerf(u.id, 2026, month, baseUnitFat[u.id] || 30000));
  });
});

// ═══════════════════════════════════════════════════════════════════════
// Override SEED_UNIT_PERFORMANCE with real Avec unit data (report 0032)
// geracaoDemanda = clientesNovos + semPreferencia (report 0326)
// ═══════════════════════════════════════════════════════════════════════
const AVEC_UNIT_DATA = [
  AVEC_VILA_OLIMPIA, AVEC_MOEMA, AVEC_ITAIM_BIBI, AVEC_OSCAR_FREIRE, AVEC_JARDINS,
];

const AVEC_SEM_PREF_DATA = [
  AVEC_SEM_PREF_VILA, AVEC_SEM_PREF_MOEMA, AVEC_SEM_PREF_ITAIM, AVEC_SEM_PREF_OSCAR, AVEC_SEM_PREF_JARDINS,
];

const AVEC_PREF_DATA = [
  AVEC_PREF_VILA, AVEC_PREF_MOEMA, AVEC_PREF_ITAIM, AVEC_PREF_OSCAR, AVEC_PREF_JARDINS,
];

// Build sem preferência lookup: unitId|monthKey -> value
const semPrefLookup = {};
AVEC_SEM_PREF_DATA.forEach(sp => {
  Object.entries(sp.months).forEach(([monthKey, val]) => {
    semPrefLookup[`${sp.unitId}|${monthKey}`] = val;
  });
});

// Build preferencial lookup: unitId|monthKey -> value
const prefLookup = {};
AVEC_PREF_DATA.forEach(p => {
  Object.entries(p.months).forEach(([monthKey, val]) => {
    prefLookup[`${p.unitId}|${monthKey}`] = val;
  });
});

const unitPerfIndex = {};
SEED_UNIT_PERFORMANCE.forEach((up, idx) => {
  const key = `${up.unitId}|${up.year}-${String(up.month).padStart(2, '0')}`;
  unitPerfIndex[key] = idx;
});

AVEC_UNIT_DATA.forEach(unitData => {
  Object.entries(unitData.months).forEach(([monthKey, data]) => {
    const key = `${unitData.unitId}|${monthKey}`;
    const idx = unitPerfIndex[key];
    if (idx === undefined) return;

    const up = SEED_UNIT_PERFORMANCE[idx];
    up.faturamento = data.faturamento;
    up.servicosRealizados = data.servicosQty;
    up.clientesAtendidos = data.visitas;
    up.clientesNovos = data.clientesNovos;
    up.ticketMedio = data.visitas > 0 ? Math.round(data.faturamento / data.visitas) : 0;
    up.produtosVendidos = data.produtosQty;
    up.faturamentoProdutos = data.produtosFat;
    // Geração de demanda da unidade = clientes novos + sem preferência (0326).
    const semPref = semPrefLookup[key] || 0;
    up.geracaoDemanda = data.clientesNovos + semPref;
    // Agendamentos preferenciais = sum of Preferencial column from report 0326
    const pref = prefLookup[key] || 0;
    up.agendamentosPreferenciais = pref;
    // Store semPreferencia separately for the comparative chart
    up.semPreferencia = semPref;
  });
});

// Zero out Jardins data for months before it opened (Feb 2026)
SEED_UNIT_PERFORMANCE.forEach(up => {
  if (up.unitId !== 'unit-jardins') return;
  const monthKey = `${up.year}-${String(up.month).padStart(2, '0')}`;
  if (monthKey < '2026-02') {
    up.faturamento = 0; up.comissao = 0; up.servicosRealizados = 0;
    up.clientesAtendidos = 0; up.clientesNovos = 0; up.geracaoDemanda = 0;
    up.agendamentosPreferenciais = 0; up.semPreferencia = 0;
    up.ticketMedio = 0; up.produtosVendidos = 0; up.faturamentoProdutos = 0;
    up.taxaRetorno = 0; up.satisfacao = 0;
  }
});

// --- Meta x Realizado seed data ---

export const SEED_HOLIDAYS = [
  { id: 'hol-2026-01-01', date: '2026-01-01', name: 'Fechado' },
  { id: 'hol-2026-02-16', date: '2026-02-16', name: 'Fechado' },
  { id: 'hol-2026-02-17', date: '2026-02-17', name: 'Fechado' },
  { id: 'hol-2026-04-03', date: '2026-04-03', name: 'Fechado' },
  { id: 'hol-2026-04-21', date: '2026-04-21', name: 'Fechado' },
  { id: 'hol-2026-05-01', date: '2026-05-01', name: 'Fechado' },
  { id: 'hol-2026-06-04', date: '2026-06-04', name: 'Fechado' },
  { id: 'hol-2026-09-07', date: '2026-09-07', name: 'Fechado' },
  { id: 'hol-2026-10-12', date: '2026-10-12', name: 'Fechado' },
  { id: 'hol-2026-11-02', date: '2026-11-02', name: 'Fechado' },
  { id: 'hol-2026-11-15', date: '2026-11-15', name: 'Fechado' },
  { id: 'hol-2026-12-25', date: '2026-12-25', name: 'Fechado' },
];

// ─── Comissão escalonada por unidade (Barbeiros) ─────────────────────────────
// Tiers em ordem crescente. Cada item = { until, percent }.
//   - "until": teto de faturamento bruto pessoal (R$) — abaixo deste valor,
//     a comissão é o `percent`. O último tier usa `until: null` (sem teto).
//   - "percent": % aplicado sobre o faturamento bruto do barbeiro.
//
// Regras atuais (produção desde nov/2026, +4k pelo aumento de preço):
//   Jardins / Oscar Freire: 35% até 27k, 37% até 40k, 39% acima
//   Vila Olímpia / Moema / Itaim Bibi: 35% até 22k, 38% até 27k, 40% até 40k, 42% acima
// Até a produção de out/2026: 23k/36k e 18k/23k/36k (vigências em commissionTiers.js).
//
// Vale APENAS para Barbeiros. Outros cargos seguem regra fixa fora deste array.
const COMMISSION_TIERS_3 = [
  { until: 27000, percent: 35 },
  { until: 40000, percent: 37 },
  { until: null,  percent: 39 },
];
const COMMISSION_TIERS_4 = [
  { until: 22000, percent: 35 },
  { until: 27000, percent: 38 },
  { until: 40000, percent: 40 },
  { until: null,  percent: 42 },
];

function defaultCommissionTiers(unitId) {
  // Jardins e Oscar Freire usam o esquema de 3 tiers
  if (unitId === 'unit-jardins' || unitId === 'unit-oscar') return COMMISSION_TIERS_3;
  // Vila, Moema, Itaim usam 4 tiers
  return COMMISSION_TIERS_4;
}

export const SEED_UNIT_CONFIG = SEED_UNITS.map(u => ({
  id: `ucfg-${u.id}`,
  unitId: u.id,
  worksOnSunday: false,
  commissionTiers: defaultCommissionTiers(u.id),
  updatedAt: '2024-01-01T00:00:00.000Z',
}));

export const SEED_UNIT_METAS = [];
const metaBases = {
  'unit-vila': { q: 85000, m: 170000 },
  'unit-moema': { q: 90000, m: 180000 },
  'unit-itaim': { q: 75000, m: 150000 },
  'unit-oscar': { q: 60000, m: 120000 },
  'unit-jardins': { q: 80000, m: 160000 },
};
SEED_UNITS.forEach(u => {
  [1, 2, 3].forEach(month => {
    const base = metaBases[u.id] || { q: 70000, m: 140000 };
    SEED_UNIT_METAS.push({
      id: `umeta-${u.id}-2026-${month}`,
      unitId: u.id,
      year: 2026,
      month,
      metaQuinzenal: base.q,
      metaMensal: base.m,
      updatedAt: '2024-01-01T00:00:00.000Z',
    });
  });
});

export const SEED_DAILY_REVENUE = [];
function genDailyRevenue(unitId, year, month, avgDaily) {
  const daysInMonth = new Date(year, month, 0).getDate();
  const records = [];
  for (let d = 1; d <= daysInMonth; d++) {
    const date = `${year}-${String(month).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
    const dayOfWeek = new Date(year, month - 1, d).getDay();
    if (dayOfWeek === 0) continue; // skip Sundays by default
    const seed = (unitId + date).split('').reduce((a, c) => a + c.charCodeAt(0), 0);
    const variation = 0.7 + ((seed * 9301 + 49297) % 233280) / 233280 * 0.6;
    records.push({
      id: `drev-${unitId}-${date}`,
      unitId,
      date,
      revenue: Math.round(avgDaily * variation),
      updatedAt: '2024-01-01T00:00:00.000Z',
    });
  }
  return records;
}
const avgDailyByUnit = {
  'unit-vila': 7000, 'unit-moema': 7500, 'unit-itaim': 6200,
  'unit-oscar': 5000, 'unit-jardins': 6600,
};
SEED_UNITS.forEach(u => {
  const avg = avgDailyByUnit[u.id] || 6000;
  // Jan and Feb 2026 fully filled
  [1, 2].forEach(month => {
    SEED_DAILY_REVENUE.push(...genDailyRevenue(u.id, 2026, month, avg));
  });
  // March 2026 partial (up to day 13)
  if (u.id === 'unit-vila') return; // Vila Olímpia uses real Avec data below
  const marchDays = 13;
  for (let d = 1; d <= marchDays; d++) {
    const date = `2026-03-${String(d).padStart(2,'0')}`;
    const dayOfWeek = new Date(2026, 2, d).getDay();
    if (dayOfWeek === 0) continue;
    const seed = (u.id + date).split('').reduce((a, c) => a + c.charCodeAt(0), 0);
    const variation = 0.7 + ((seed * 9301 + 49297) % 233280) / 233280 * 0.6;
    SEED_DAILY_REVENUE.push({
      id: `drev-${u.id}-${date}`,
      unitId: u.id,
      date,
      revenue: Math.round(avg * variation),
      updatedAt: '2024-01-01T00:00:00.000Z',
    });
  }
});

// Vila Olímpia REAL daily revenue from Avec (01/03 - 13/03/2026)
const vilaRealRevenue = [
  { date: '2026-03-02', revenue: 3440 },
  { date: '2026-03-03', revenue: 2480 },
  { date: '2026-03-04', revenue: 5495 },
  { date: '2026-03-05', revenue: 4057 },
  { date: '2026-03-06', revenue: 5460 },
  { date: '2026-03-07', revenue: 7165 },
  { date: '2026-03-09', revenue: 4105 },
  { date: '2026-03-10', revenue: 3725 },
  { date: '2026-03-11', revenue: 4865 },
  { date: '2026-03-12', revenue: 6350 },
  { date: '2026-03-13', revenue: 7360 },
];
vilaRealRevenue.forEach(r => {
  SEED_DAILY_REVENUE.push({
    id: `drev-unit-vila-${r.date}`,
    unitId: 'unit-vila',
    date: r.date,
    revenue: r.revenue,
    updatedAt: '2024-01-01T00:00:00.000Z',
  });
});

function genPerf(professionalId, unitId, year, month, base) {
  const seed = (professionalId + year + month).split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  const rng = (min, max) => min + ((seed * 9301 + 49297) % 233280) / 233280 * (max - min);
  const rngN = (min, max, n) => min + (((seed + n * 97) * 9301 + 49297) % 233280) / 233280 * (max - min);
  const fat = Math.round(base * (0.85 + rng(0, 0.3)));
  const servicosRealizados = Math.round((80 + rng(0, 120)) * (0.85 + rng(0, 0.3)));
  const clientesAtendidos = Math.round(servicosRealizados * (0.6 + rng(0, 0.2)));
  return {
    id: `perf-${professionalId}-${year}-${month}`,
    professionalId, unitId, year, month,
    faturamento: fat,
    comissao: Math.round(fat * (0.4 + rng(0, 0.1))),
    servicosRealizados,
    clientesAtendidos,
    clientesNovos: Math.round(10 + rng(0, 25)),
    agendamentosPreferenciais: Math.round(servicosRealizados * 0.3),
    ticketMedio: clientesAtendidos > 0 ? Math.round(fat / clientesAtendidos) : 0,
    produtosVendidos: Math.round(5 + rng(0, 20)),
    taxaRetorno: Math.round(65 + rng(0, 20)),
    taxaResposta: Math.round(50 + rng(0, 40)),
    satisfacao: Math.round(80 + rng(0, 18)),
    motorTracao: Math.round(fat * 0.4),
    metaMensal: Math.round(base * 1.1),
    observacoes: '',
    servicosExtras: {
      'svc-sobrancelha': Math.round(rngN(1, 15, 1)),
      'svc-barboterapia': Math.round(rngN(0, 8, 3)),
      'svc-botox': Math.round(rngN(0, 4, 4)),
      'svc-depilacao': Math.round(rngN(0, 12, 5)),
      'svc-terapia-facial': Math.round(rngN(0, 3, 8)),
      'svc-mascara-argila': Math.round(rngN(0, 3, 9)),
      'svc-disfarce': Math.round(rngN(0, 7, 10)),
    },
    pacotesVendidos: {
      'pkg-basic': Math.round(rngN(0, 10, 9)),
      'pkg-premium': Math.round(rngN(0, 6, 10)),
      'pkg-vip': Math.round(rngN(0, 4, 11)),
    },
    metaPacotes: 0,
    updatedAt: '2024-01-01T00:00:00.000Z'
  };
}

const baseFat = {
  // Jardins
  'p-jardins-caio': 10000, 'p-jardins-henrique': 9500, 'p-jardins-renato': 10500,
  'p-jardins-isabela': 7000, 'p-jardins-isabelly': 4500, 'p-jardins-jhenifer': 5500,
  'p-jardins-giulia': 4200, 'p-jardins-eduarda': 4000,
  // Vila Olímpia
  'p-vila-day': 8400, 'p-vila-gringo': 11000, 'p-vila-leonardo': 11400, 'p-vila-luan': 9700, 'p-vila-matheus': 13700,
  'p-vila-anna-jullya': 4500, 'p-vila-ana-vitoria': 4500,
  'p-vila-jhenifer-lopes': 4200, 'p-vila-julia': 4000,
  // Itaim Bibi
  'p-itaim-diego': 10800, 'p-itaim-fernando': 9500, 'p-itaim-matheus': 10000, 'p-itaim-victoria': 8800,
  'p-itaim-eduarda': 4800, 'p-itaim-maria-eloysa': 4500,
  // Moema
  'p-moema-dan': 12000, 'p-moema-kayk': 10500, 'p-moema-mariana': 9800, 'p-moema-narciso': 11000,
  'p-moema-regiane': 9000, 'p-moema-eduardo': 10000, 'p-moema-henrique': 8500,
  'p-moema-duda': 5000, 'p-moema-katy': 5500, 'p-moema-ana': 4200, 'p-moema-kauanny': 4000,
  // Oscar Freire
  'p-oscar-franco': 13000, 'p-oscar-gabriel': 9500, 'p-oscar-luiz-grolla': 11000, 'p-oscar-pedro': 10000, 'p-oscar-victor': 9000,
  'p-oscar-giovanna': 5500, 'p-oscar-maria': 4200, 'p-oscar-sarah': 4000,
};

export const SEED_PERFORMANCE = [];
SEED_PROFESSIONALS.forEach(p => {
  [2024, 2025].forEach(year => {
    const months = year === 2024 ? [9,10,11,12] : [1,2,3,4,5,6,7,8,9,10,11,12];
    months.forEach(month => {
      SEED_PERFORMANCE.push(genPerf(p.id, p.unitId, year, month, baseFat[p.id] || 10000));
    });
  });
  [1,2,3].forEach(month => {
    SEED_PERFORMANCE.push(genPerf(p.id, p.unitId, 2026, month, baseFat[p.id] || 10000));
  });
});
// Set metaPacotes for recepcionistas
SEED_PERFORMANCE.forEach(perf => {
  const pro = SEED_PROFESSIONALS.find(p => p.id === perf.professionalId);
  if (pro && pro.role === 'Recepcionista') {
    perf.metaPacotes = 30;
  }
});

// ═══════════════════════════════════════════════════════════════════════
// Override servicosExtras with REAL data from Avec SalãoVIP (report 0032)
// Maps Avec service names → system service IDs, distributes unit totals
// among professionals of the matching role category
// ═══════════════════════════════════════════════════════════════════════

const AVEC_SERVICE_MAP = {
  // Sobrancelha (todas variantes unificadas) → svc-sobrancelha
  'Aparar Sobrancelha': 'svc-sobrancelha',
  'Aparar Sobrancelhas': 'svc-sobrancelha',
  'Aparar sobrancelha': 'svc-sobrancelha',
  'Sobrancelha': 'svc-sobrancelha',
  'Sobrancelha cera': 'svc-sobrancelha',
  'Sobrancelha na Cera': 'svc-sobrancelha',
  'Sobrancelha na cera': 'svc-sobrancelha',
  'Sobrancelha Navalha': 'svc-sobrancelha',
  'Sobrancelha navalha': 'svc-sobrancelha',
  'Sobrancelha na Navalha': 'svc-sobrancelha',
  // Barbeiro extras
  'Barboterapia': 'svc-barboterapia',
  'Botox Capilar': 'svc-botox',
  'Desondulação (botox)': 'svc-botox',
  'Desondulação Botox': 'svc-botox',
  'Desondulação botox': 'svc-botox',
  'Desondulacao (botox)': 'svc-botox',
  'Depilação Nariz': 'svc-depilacao',
  'Depillação Nariz': 'svc-depilacao',
  'Depilação de Nariz': 'svc-depilacao',
  'Depilação nariz ou orelha': 'svc-depilacao',
  'Depilação Orelha': 'svc-depilacao',
  'Depilação de Orelha': 'svc-depilacao',
  'Depilação Orelha  Nariz': 'svc-depilacao',
  'Depilação Orelha e Nariz': 'svc-depilacao',
  'Depilção Nariz e Orelha': 'svc-depilacao',
  'Depilação de Nariz e Orelha': 'svc-depilacao',
  'Depilação nariz e orelha': 'svc-depilacao',
  'Terapia Facial': 'svc-terapia-facial',
  'Terapia facial': 'svc-terapia-facial',
  'Máscara de Argila': 'svc-mascara-argila',
  'Disfarce de grisalhos barba (keune)': 'svc-disfarce',
  'Disfarce de grisalhos Barba': 'svc-disfarce',
  'Disfarce de grisalho Barba': 'svc-disfarce',
  'Disfarce de grisalhos (barba Keune)': 'svc-disfarce',
  'Pigmentação de Barba': 'svc-disfarce',
  'Disfarce de grisalho cabelo (keune)': 'svc-disfarce',
  'Disfarce de grisalhos Cabelo': 'svc-disfarce',
  'Disfarce Grisalho Cabelo': 'svc-disfarce',
  'Disfarce de grisalhos (cabelo Keune)': 'svc-disfarce',
  'Disfarce de grisalhos de Cabelo': 'svc-disfarce',
  // Assistente extras
  'Hidratação': 'svc-hidratacao',
  'Lavagem especial': 'svc-lavagem-especial',
  'Lavagem Especial': 'svc-lavagem-especial',
  // Manicure extras
  'Manicure': 'svc-manicure-pedicure',
  'Pedicure': 'svc-manicure-pedicure',
  'Reflexologia': 'svc-reflexologia',
  'Spa para os Pés': 'svc-spa-pes',
  'Hidratação dos pés': 'svc-hidratacao-pes',
  'Massagem nos Pés': 'svc-massagem-pes',
  // Esteticista extras
  'Limpeza Facial': 'svc-limpeza-pele',
  'Limpeza de Pele': 'svc-limpeza-pele',
  'Massagem relaxante': 'svc-massagem-relaxante-30',
};

// Multiplier por linha de serviço Avec.
//
// Caso especial: linha "Depilação Nariz e Orelha" da Avec é AGREGADA —
// cada combo já foi contado individualmente nas linhas "Depilação Nariz"
// e "Depilação Orelha". Somar a linha agregada por cima = duplicar contagem.
// Por isso o multiplier do combo é 0 (ignora a linha).
//
// Comportamento mantém a regra "1 combo = 2 depilações" porque a Avec
// já lançou 1 nariz + 1 orelha pra cada combo.
//
// Verificado empiricamente em Renato/Jardins/mar26: real=45, sistema com
// multiplier 2 dava 68. Com 0 dá 45 ✓.
function getServiceMultiplier(serviceName) {
  const n = String(serviceName || '')
    .toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .trim();
  const hasDepilation = n.includes('depilacao') || n.includes('depilcao') || n.includes('depillacao');
  if (hasDepilation && n.includes('nariz') && n.includes('orelha')) return 0;
  return 1;
}

// Build service category lookup
const SVC_CATEGORY = {};
SEED_SERVICES.forEach(s => { SVC_CATEGORY[s.id] = s.category; });

// Build unit extras lookup: { unitId: { 'YYYY-MM': { svcId: totalQty } } }
function buildExtrasLookup() {
  const lookup = {};
  [AVEC_EXTRAS_VILA, AVEC_EXTRAS_OSCAR, AVEC_EXTRAS_MOEMA, AVEC_EXTRAS_ITAIM, AVEC_EXTRAS_JARDINS].forEach(unitData => {
    lookup[unitData.unitId] = {};
    Object.entries(unitData.months).forEach(([monthKey, services]) => {
      const mapped = {};
      services.forEach(({ service, qty }) => {
        const svcId = AVEC_SERVICE_MAP[service];
        if (svcId) {
          const multiplier = getServiceMultiplier(service);
          mapped[svcId] = (mapped[svcId] || 0) + (qty * multiplier);
        }
      });
      lookup[unitData.unitId][monthKey] = mapped;
    });
  });
  return lookup;
}

const EXTRAS_LOOKUP = buildExtrasLookup();

// Supplement: Lavagem Especial data missing from original AVEC_EXTRAS extraction
// Extracted from Avec report 0032 per unit
const LAVAGEM_SUPPLEMENT = {
  'unit-vila': { '2026-02': 24, '2026-03': 6 },
  'unit-moema': { '2025-12': 75, '2026-01': 69, '2026-02': 50, '2026-03': 21 },
  'unit-oscar': { '2025-11': 8, '2025-12': 1, '2026-01': 1, '2026-02': 29, '2026-03': 8 },
};
// Merge Lavagem Especial into EXTRAS_LOOKUP
Object.entries(LAVAGEM_SUPPLEMENT).forEach(([unitId, months]) => {
  if (!EXTRAS_LOOKUP[unitId]) EXTRAS_LOOKUP[unitId] = {};
  Object.entries(months).forEach(([monthKey, qty]) => {
    if (!EXTRAS_LOOKUP[unitId][monthKey]) EXTRAS_LOOKUP[unitId][monthKey] = {};
    EXTRAS_LOOKUP[unitId][monthKey]['svc-lavagem-especial'] = (EXTRAS_LOOKUP[unitId][monthKey]['svc-lavagem-especial'] || 0) + qty;
  });
});

// Pre-index professionals by unit+role for fast lookup
const prosByUnitRole = {};
SEED_PROFESSIONALS.forEach(p => {
  const key = `${p.unitId}|${p.role}`;
  if (!prosByUnitRole[key]) prosByUnitRole[key] = [];
  prosByUnitRole[key].push(p.id);
});

// Distribute total exactly among N professionals, preserving the sum.
// Uses floor + remainder so sum of shares === total always.
function distributeExact(total, numPros, proIndex) {
  const base = Math.floor(total / numPros);
  const remainder = total % numPros;
  return base + (proIndex < remainder ? 1 : 0);
}

// For each service, determine which role group receives it.
// If a unit has no professionals of the matching role, fall back to Barbeiros.
function getTargetPros(unitId, svcCategory) {
  const roleKey = `${unitId}|${svcCategory}`;
  const pros = prosByUnitRole[roleKey];
  if (pros && pros.length > 0) return pros;
  // Fallback: assign to Barbeiros if no matching role exists in unit
  return prosByUnitRole[`${unitId}|Barbeiro`] || [];
}

// Override servicosExtras with real Avec data, distributed among professionals
SEED_PERFORMANCE.forEach(perf => {
  const pro = SEED_PROFESSIONALS.find(p => p.id === perf.professionalId);
  if (!pro) return;

  const monthKey = `${perf.year}-${String(perf.month).padStart(2, '0')}`;
  const unitExtras = EXTRAS_LOOKUP[perf.unitId]?.[monthKey];
  if (!unitExtras) return; // No real data → keep generated extras

  const newExtras = {};
  Object.entries(unitExtras).forEach(([svcId, totalQty]) => {
    const svcCategory = SVC_CATEGORY[svcId];
    if (!svcCategory || svcCategory === 'Geral') return;

    const targetPros = getTargetPros(perf.unitId, svcCategory);
    const proIndex = targetPros.indexOf(pro.id);
    if (proIndex === -1) return; // This professional is not in the target group

    const share = distributeExact(totalQty, targetPros.length, proIndex);
    if (share > 0) {
      newExtras[svcId] = share;
    }
  });

  perf.servicosExtras = newExtras;
});

// ═══════════════════════════════════════════════════════════════════════
// Override faturamento/servicosRealizados/clientesAtendidos/ticketMedio
// with REAL data from Avec SalãoVIP (report 0021 - Faturamento por profissional)
// ═══════════════════════════════════════════════════════════════════════

function parseBR(str) {
  if (!str || str === '0' || str === '0,00') return 0;
  return parseFloat(str.replace(/\./g, '').replace(',', '.'));
}

// Avec name → system professional ID
const AVEC_PRO_NAME_MAP = {
  'unit-vila': {
    'Daiane Fabiano dos Santos': 'p-vila-day',
    'Eduardo Isaac Chacon Mansilla': 'p-vila-gringo',
    'Leonardo Rocholi': 'p-vila-leonardo',
    'Luan Pires de Lima': 'p-vila-luan',
    'Matheus Prado Ribeiro': 'p-vila-matheus',
    'Ana Vitória': 'p-vila-ana-vitoria',
    'Anna Jullya': 'p-vila-anna-jullya',
    'Ana Jullya': 'p-vila-anna-jullya',
    'Jhenifer Lopes': 'p-vila-jhenifer-lopes',
    'Julia': 'p-vila-julia',
  },
  'unit-moema': {
    'Danilo Macedo': 'p-moema-dan',
    'Narciso Cruz pavani': 'p-moema-narciso',
    'Narciso Cruz Pavani': 'p-moema-narciso',
    'Regiane Alves': 'p-moema-regiane',
    'Silvio Eduardo do Nascimento Fragoso': 'p-moema-eduardo',
    'Victor Henrique Rodrigues da Silva': 'p-moema-henrique',
    'Ana': 'p-moema-ana',
    'Maria Eduarda Gomes de Aquino': 'p-moema-duda',
    'Katy Ferraz de Almeida': 'p-moema-katy',
    'Kauanny Lopes': 'p-moema-kauanny',
    'Kayk Araujo Ferreira de Lima': 'p-moema-kayk',
    'Mariana Marques Farias': 'p-moema-mariana',
  },
  'unit-itaim': {
    'Matheus de Jesus Sanches': 'p-itaim-matheus',
    'Victória Pereira Barbosa da Silva': 'p-itaim-victoria',
    'Diego Costa Paulino de Souza Santos': 'p-itaim-diego',
    'Fernando Ferreira da Silva Junior': 'p-itaim-fernando',
    'Maria Eduarda Reis': 'p-itaim-eduarda',
    'Maria Eloysa': 'p-itaim-maria-eloysa',
  },
  'unit-oscar': {
    'Franco Saturnini': 'p-oscar-franco',
    'Gabriel Renan de Oliveira': 'p-oscar-gabriel',
    'Luiz Felipe Grolla Machado': 'p-oscar-luiz-grolla',
    'Pedro Henrique Carezzato': 'p-oscar-pedro',
    'Victor Hugo Elias': 'p-oscar-victor',
    'Giovanna do Santos': 'p-oscar-giovanna',
    'Giovanna dos Santos': 'p-oscar-giovanna',
    'Maria Clara Gama Holanda': 'p-oscar-maria',
    'Sarah Lays Souza Melo': 'p-oscar-sarah',
  },
  'unit-jardins': {
    'Caio Henrique': 'p-jardins-caio',
    'Henrique Sarrico': 'p-jardins-henrique',
    'Renato Schittini': 'p-jardins-renato',
    'Renato Damas Schittini': 'p-jardins-renato',
    'Isabela Vitória dos Santos Silva': 'p-jardins-isabela',
    'Isabelly sousa': 'p-jardins-isabelly',
    'Isabelly Souza': 'p-jardins-isabelly',
    'Jhenifer Trindade Ferreira': 'p-jardins-jhenifer',
    'Giulia Castellan': 'p-jardins-giulia',
    'Maria Eduarda Alves': 'p-jardins-eduarda',
  },
};

// Index SEED_PERFORMANCE for fast lookup: key = "proId|YYYY-MM"
const perfIndex = {};
SEED_PERFORMANCE.forEach((perf, idx) => {
  const key = `${perf.professionalId}|${perf.year}-${String(perf.month).padStart(2, '0')}`;
  perfIndex[key] = idx;
});

// Track which pro+month combos get real Avec data
const avecProMonths = new Set();

// Build set of unit+month combos that have Avec unit-level data
const avecUnitMonths = new Set();
AVEC_UNIT_DATA.forEach(unitData => {
  Object.keys(unitData.months).forEach(monthKey => {
    avecUnitMonths.add(`${unitData.unitId}|${monthKey}`);
  });
});

// Apply real Avec professional data
[AVEC_PRO_VILA, AVEC_PRO_MOEMA, AVEC_PRO_ITAIM, AVEC_PRO_OSCAR, AVEC_PRO_JARDINS].forEach(unitData => {
  const nameMap = AVEC_PRO_NAME_MAP[unitData.unitId];
  if (!nameMap) return;

  Object.entries(unitData.months).forEach(([monthKey, rows]) => {
    rows.forEach(([rawName, faturamento, comandas, clientes, ticketMedio]) => {
      const name = rawName.trim();
      const proId = nameMap[name];
      if (!proId) return; // Skip owners, former employees, non-system people

      const perfKey = `${proId}|${monthKey}`;
      avecProMonths.add(perfKey); // Track this pro has real data

      const idx = perfIndex[perfKey];
      if (idx === undefined) return; // No matching performance record

      const perf = SEED_PERFORMANCE[idx];
      const fat = parseBR(faturamento);
      const cmds = parseInt(comandas) || 0;
      const cli = parseInt(clientes) || 0;
      const tm = parseBR(ticketMedio);

      perf.faturamento = fat;
      perf.servicosRealizados = cmds;
      perf.clientesAtendidos = cli;
      perf.ticketMedio = tm > 0 ? tm : (cli > 0 ? Math.round((fat / cli) * 100) / 100 : 0);

      // Commission is now overridden below with real Avec data (report 0123)

      // Motor de tração: % of personal meta achieved (meta = baseFat * 1.2)
      const meta = (baseFat[proId] || 10000) * 1.2;
      perf.motorTracao = meta > 0 ? Math.min(Math.round((fat / meta) * 100), 200) : 0;
    });
  });
});

// ═══════════════════════════════════════════════════════════════════════
// Override comissao with REAL data from Avec SalãoVIP (report 0123 - "A pagar")
// ═══════════════════════════════════════════════════════════════════════

const AVEC_COM_NAME_MAP = {
  'unit-vila': {
    'Daiane Fabiano dos Santos': 'p-vila-day',
    'Eduardo Isaac Chacon Mansilla': 'p-vila-gringo',
    'Leonardo Rocholi': 'p-vila-leonardo',
    'Luan Pires de Lima': 'p-vila-luan',
    'Matheus Prado Ribeiro': 'p-vila-matheus',
    'Ana Vitória': 'p-vila-ana-vitoria',
    'Ana Jullya': 'p-vila-anna-jullya',
    'Jhenifer Lopes': 'p-vila-jhenifer-lopes',
    'Julia': 'p-vila-julia',
  },
  'unit-moema': {
    'Danilo Macedo': 'p-moema-dan',
    'Narciso Cruz pavani': 'p-moema-narciso',
    'Narciso Cruz pavani ': 'p-moema-narciso',
    'Regiane Alves': 'p-moema-regiane',
    'Silvio Eduardo do Nascimento Fragoso': 'p-moema-eduardo',
    'Victor Henrique Rodrigues da Silva': 'p-moema-henrique',
    'Ana': 'p-moema-ana',
    'Maria Eduarda Gomes de Aquino': 'p-moema-duda',
    'Katy Ferraz de Almeida': 'p-moema-katy',
    'Kauanny Lopes ': 'p-moema-kauanny',
    'Kayk Araujo Ferreira de Lima': 'p-moema-kayk',
    'Mariana Marques Farias': 'p-moema-mariana',
  },
  'unit-itaim': {
    'Matheus de Jesus Sanches': 'p-itaim-matheus',
    'Victória Pereira Barbosa da Silva': 'p-itaim-victoria',
    'Diego Costa Paulino de Souza Santos': 'p-itaim-diego',
    'Fernando Ferreira da Silva Junior': 'p-itaim-fernando',
    'Maria Eduarda Reis': 'p-itaim-eduarda',
    'Maria Eloysa': 'p-itaim-maria-eloysa',
  },
  'unit-oscar': {
    'Franco Saturnini': 'p-oscar-franco',
    'Gabriel Renan de Oliveira': 'p-oscar-gabriel',
    'Luiz Felipe Grolla Machado': 'p-oscar-luiz-grolla',
    'Pedro Henrique Carezzato': 'p-oscar-pedro',
    'Victor Hugo Elias': 'p-oscar-victor',
    'Giovanna do Santos': 'p-oscar-giovanna',
    'Giovanna dos Santos': 'p-oscar-giovanna',
    'Maria Clara Gama Holanda': 'p-oscar-maria',
    'Maria Eduarda Alves Souza Pereira': 'p-oscar-maria',
    'Sarah Lays Souza Melo': 'p-oscar-sarah',
  },
  'unit-jardins': {
    'Caio Henrique': 'p-jardins-caio',
    'Henrique Sarrico': 'p-jardins-henrique',
    'Renato Schittini': 'p-jardins-renato',
    'Isabela Vitória dos Santos Silva': 'p-jardins-isabela',
    'Isabelly sousa': 'p-jardins-isabelly',
    'Jhenifer Trindade Ferreira': 'p-jardins-jhenifer',
    'Giulia Castellan': 'p-jardins-giulia',
    'Maria Eduarda Alves': 'p-jardins-eduarda',
  },
};

// Apply real Avec commission data
[AVEC_COM_VILA, AVEC_COM_MOEMA, AVEC_COM_ITAIM, AVEC_COM_OSCAR, AVEC_COM_JARDINS].forEach(unitData => {
  const nameMap = AVEC_COM_NAME_MAP[unitData.unitId];
  if (!nameMap) return;

  Object.entries(unitData.months).forEach(([monthKey, rows]) => {
    rows.forEach(([rawName, aPagar]) => {
      const name = rawName.trim();
      const proId = nameMap[name];
      if (!proId) return; // Skip owners, former employees, non-system people

      const perfKey = `${proId}|${monthKey}`;
      avecProMonths.add(perfKey); // Also track commission-only appearances
      const idx = perfIndex[perfKey];
      if (idx === undefined) return; // No matching performance record

      const perf = SEED_PERFORMANCE[idx];
      perf.comissao = parseBR(aPagar);
    });
  });
});

// Recalculate unit-level comissao by summing all professional commissions for each unit/month
// This replaces the randomly generated unit commission with real totals from Avec data
const unitComSums = {};
SEED_PERFORMANCE.forEach(perf => {
  const monthKey = `${perf.year}-${String(perf.month).padStart(2, '0')}`;
  const unitMonthKey = `${perf.unitId}|${monthKey}`;
  // Only sum for months where the unit has real Avec data
  if (avecUnitMonths.has(unitMonthKey)) {
    unitComSums[unitMonthKey] = (unitComSums[unitMonthKey] || 0) + (perf.comissao || 0);
  }
});
Object.entries(unitComSums).forEach(([unitMonthKey, totalCom]) => {
  const idx = unitPerfIndex[unitMonthKey];
  if (idx !== undefined) {
    SEED_UNIT_PERFORMANCE[idx].comissao = Math.round(totalCom * 100) / 100;
  }
});

// Zero out professional performance for months where:
// 1. The unit has real Avec data for that month, BUT
// 2. The professional does NOT appear in the Avec data for that month
// This removes fake generated data for professionals who weren't working at the unit yet.
SEED_PERFORMANCE.forEach(perf => {
  const monthKey = `${perf.year}-${String(perf.month).padStart(2, '0')}`;
  const unitMonthKey = `${perf.unitId}|${monthKey}`;
  const proMonthKey = `${perf.professionalId}|${monthKey}`;

  // If the unit has Avec data for this month but this professional doesn't, zero it out
  if (avecUnitMonths.has(unitMonthKey) && !avecProMonths.has(proMonthKey)) {
    perf.faturamento = 0; perf.comissao = 0; perf.servicosRealizados = 0;
    perf.clientesAtendidos = 0; perf.clientesNovos = 0; perf.ticketMedio = 0;
    perf.produtosVendidos = 0; perf.taxaRetorno = 0; perf.satisfacao = 0;
    perf.motorTracao = 0; perf.servicosExtras = {};
    perf.pacotesVendidos = { 'pkg-basic': 0, 'pkg-premium': 0, 'pkg-vip': 0 };
  }

  // For ALL professionals in months with real Avec data: zero out pacotesVendidos
  // (receptionists will get real data assigned below)
  if (avecUnitMonths.has(unitMonthKey)) {
    perf.pacotesVendidos = { 'pkg-basic': 0, 'pkg-premium': 0, 'pkg-vip': 0 };
  }
});

// ── Assign REAL package data to receptionists from Avec unit-level pacotes revenue ──
// Avec gives us total package revenue per unit/month. We distribute among receptionists.
// Package prices: basic=R$80, premium=R$150, vip=R$220
// Distribution estimate: 50% basic, 35% premium, 15% vip → weighted avg = R$125.50
const AVEC_UNITS_DATA = { 'unit-vila': AVEC_VILA_OLIMPIA, 'unit-itaim': AVEC_ITAIM_BIBI, 'unit-moema': AVEC_MOEMA, 'unit-oscar': AVEC_OSCAR_FREIRE, 'unit-jardins': AVEC_JARDINS };
const recepcionistas = SEED_PROFESSIONALS.filter(p => p.role === 'Recepcionista');
const recepByUnit = {};
recepcionistas.forEach(r => {
  if (!recepByUnit[r.unitId]) recepByUnit[r.unitId] = [];
  recepByUnit[r.unitId].push(r.id);
});

SEED_PERFORMANCE.forEach(perf => {
  const monthKey = `${perf.year}-${String(perf.month).padStart(2, '0')}`;
  const unitMonthKey = `${perf.unitId}|${monthKey}`;
  if (!avecUnitMonths.has(unitMonthKey)) return;

  const unitReceps = recepByUnit[perf.unitId];
  if (!unitReceps || !unitReceps.includes(perf.professionalId)) return;

  const avecUnit = AVEC_UNITS_DATA[perf.unitId];
  if (!avecUnit) return;
  const avecMonth = avecUnit.months[monthKey];
  if (!avecMonth || !avecMonth.pacotes) return;

  const totalPacotesRevenue = avecMonth.pacotes;
  const numReceps = unitReceps.length;
  // Total packages estimated from revenue (weighted avg R$125.50)
  const totalPkgs = Math.round(totalPacotesRevenue / 125.5);
  const perRecep = Math.max(1, Math.round(totalPkgs / numReceps));
  // Split into types: 50% basic, 35% premium, 15% vip
  const basic = Math.round(perRecep * 0.50);
  const premium = Math.round(perRecep * 0.35);
  const vip = Math.max(0, perRecep - basic - premium);

  perf.pacotesVendidos = { 'pkg-basic': basic, 'pkg-premium': premium, 'pkg-vip': vip };
  // Also set faturamento from packages for the receptionist
  perf.faturamento = basic * 80 + premium * 150 + vip * 220;
});

// ═══════════════════════════════════════════════════════════════════════
// PERFORMANCE NUNCA MAIS NASCE DE SEED (06/07/2026).
// Os geradores acima criavam histórico SINTÉTICO (798 registros fake em
// produção: Jardins "faturando" antes de existir, pacotes=213 com 9
// clientes, comissão>faturamento) e o storage ainda RE-INJETAVA registros
// de seed "ausentes" em dados reais. Fonte única agora: o cloud, alimentado
// pelo avec-daily-sync com dados reais do Avec (backfill desde 2023-01).
// Esvaziar aqui (depois de toda a geração) neutraliza seed inicial E
// re-injeção, sem mexer na lógica acima.
// ═══════════════════════════════════════════════════════════════════════
SEED_PERFORMANCE.length = 0;
SEED_UNIT_PERFORMANCE.length = 0;

// ═══════════════════════════════════════════════════════════════════════
// META x REALIZADO NUNCA MAIS NASCE DE SEED (23/10/2026, rodada 2, item 1).
// Em 05/09 um aparelho com o armazenamento vazio semeou 310 dias de
// faturamento falsos (R$ 953 mil a mais na rede em jan a mar/2026) e as 15
// metas de demonstração, e o cofre recebeu tudo. Com SEED_TRAVADO os dois
// arrays saem vazios (mesmo padrão do esvaziamento acima); false = como antes.
// ═══════════════════════════════════════════════════════════════════════
if (SEED_TRAVADO) {
  SEED_DAILY_REVENUE.length = 0;
  SEED_UNIT_METAS.length = 0;
}
